import request from "../../../../helper/request";

export const vehicleTypeApi = {
  getList: () => {
    return request.get("/vehicle-categories");
  }
};
